module.exports = __webpack_public_path__ + "img/012-energy.5cb667dd.svg";